import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { NotificationsSettingsPageCatalogKey } from './notificationsSettingsPage.i18n.js';
import { NOTIFICATIONS_SETTINGS_PAGE_CATALOG } from './notificationsSettingsPage.i18n.js';

export type NotificationsSettingsPageMessageId = `notificationsSettingsPage:${NotificationsSettingsPageCatalogKey}`;

const PREFIX_LENGTH = 'notificationsSettingsPage:'.length;

/** `t()` for the stop-gap `notificationsSettingsPage:` scope (see the sibling `.i18n.ts`). */
export function useNotificationsSettingsPageT(): {
  t: (id: NotificationsSettingsPageMessageId, vars?: TranslateVars) => string;
} {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: NotificationsSettingsPageMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as NotificationsSettingsPageCatalogKey;
      const raw = NOTIFICATIONS_SETTINGS_PAGE_CATALOG[locale][key] ?? NOTIFICATIONS_SETTINGS_PAGE_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
